/**
 * informantDashboardRouting.js
 *
 * Centralises where service users (patients and informants) land after sign-in.
 *
 * ADHD users get the legacy dashboards (/patient-dashboard, /informant-dashboard).
 * Modular-assessment users (Adult Autism, CYP ADHD, and future pathways) get the
 * modular dashboards (/service-user/modular-dashboard, /informant/modular-dashboard)
 * which read from subcollection-based form instances.
 *
 * IMPORTANT: Must stay aligned with the backend mirror in
 * python-functions/functions/notification/service_user_dashboard_paths.py.
 */

import { isModularModule } from '../constants/assessmentModules';

/**
 * Returns the correct dashboard path for an informant based on their
 * assessmentModule claim.
 *
 * @param {object|null|undefined} claims - Firebase auth custom claims
 * @returns {string} Dashboard path for the informant
 */
export function getInformantDashboardPath(claims) {
  if (isModularModule(claims?.assessmentModule)) {
    return '/informant/modular-dashboard';
  }
  return '/informant-dashboard';
}

/**
 * Returns the correct dashboard path for a patient based on their
 * assessmentModule claim.  Mirrors getInformantDashboardPath so both
 * user types share a single routing decision point.
 *
 * @param {object|null|undefined} claims - Firebase auth custom claims
 * @returns {string} Dashboard path for the patient
 */
export function getPatientDashboardPath(claims) {
  if (isModularModule(claims?.assessmentModule)) {
    return '/service-user/modular-dashboard';
  }
  return '/patient-dashboard';
}
